<template>
  <v-container fill-height fluid class="d-flex justify-center align-stretch">
    <p v-if="products === null" class="infos-label">Cargando...</p>
    <p v-if="products && !products.length" class="infos-label">
      No existen productos registrados
    </p>
    <ProductoCart
      v-for="(product, index) in products"
      :key="product.id"
      :index="index"
      class="col-lg-8 col-md-8 col-sm-8 col-xs-12 ma-2"
      :is-product-deletion-pending="isProductDeletionPending(product.id)"
      :disable-actions="!networkOnLine"
      :data="product"
      @deleteProduct="deleteUserProduct"
    ></ProductoCart>
  </v-container>
</template>

<script>
import ProductoCart from '@/components/normal/ProductoCart'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: { ProductoCart },
  computed: {
    ...mapGetters('products', ['isProductDeletionPending']),
    ...mapState('products', ['products']),
    ...mapState('app', ['networkOnLine'])
  },
  methods: {
    ...mapActions('products', ['deleteUserProduct'])
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.infos-label {
  text-align: center;
}
</style>
